import { useState, Fragment } from "react";
import { searchDictations } from "apiHandler/actions/scribe";
import SearchIcon from "@material-ui/icons/Search";
import { useUserData } from "components/customHooks/userDataContext";
import SearchDictationModal from "components/modals/SearchDictation";
import { displayDateFormatter } from "components/helpers";

// type, doctors, practices are optional
const SearchDictation = ({ type, doctors, practices }) => {
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [results, setResults] = useState([]);
  const userData = useUserData();
  const token = userData?.access_token;

  const onSearch = async (e) => {
    e.preventDefault();
    if (!search) return;
    let search_criteria = { scribe_id: userData.email };
    if (type === "practice")
      search_criteria["practice_id"] = practices?.map((p) => p.practice_id);
    else if (type === "doctors")
      search_criteria["npi"] = doctors?.map((d) => d.npi);
    if (/^\d{1,2}[/]\d{1,2}[/]\d{4}$/.test(search))
      search_criteria["dob"] = search;
    else if (!isNaN(Number(search))) search_criteria["dictation_id"] = search;
    else search_criteria["patient_name"] = search;
    const payload = {
      type: "Scribe",
      search_criteria,
    };
    const response = await searchDictations(payload, token);
    if (response && response !== "ERROR") {
      setShowModal(true);
      setResults(
        response.map((r) => {
          return {
            ...r,
            updated_date: displayDateFormatter(r.updated_date),
            created_date: displayDateFormatter(r.created_date),
            dos: displayDateFormatter(r.dos),
          };
        })
      );
    }
  };

  return (
    <Fragment>
      <form className="search-dict-form">
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="sdf-input"
          placeholder="Search..."
        />
        <button type="submit" onClick={onSearch} className="sdf-btn">
          <SearchIcon fontSize="large" color="secondary" />
        </button>
        <div className="sdf-descri">
          Name: First Last <br />
          DOB: MM/DD/YYYY <br />
          Dictation id: Number
        </div>
      </form>
      {showModal && (
        <SearchDictationModal
          onClose={() => setShowModal(false)}
          results={results}
        />
      )}
    </Fragment>
  );
};

export default SearchDictation;
